export const filter = {
    id: "",
    branch_id: "",
    user_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
